import get from "lodash/get";
import React from "react";
import { useSelector } from "react-redux";

import { STATIC_KEYWORDS } from "../../../constants";
import { AppLogo, BreadCrumb } from "../../atoms";
import { FollowUsIcons } from "../../molecules/FollowUsIcons";
import { MenuGroup } from "../../molecules/FooterMenuGroup";
import StickyAd from "../../molecules/StickyAd";

import "./Footer.m.css";

export const Footer = () => {
  const navigationMenu = useSelector((state) => get(state, ["qt", "data", "navigationMenu"], {}));
  const config = useSelector((state) => get(state, ["qt", "config"], {}));
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], ""));
  const publisherSettings = useSelector((state) => get(state, ["qt", "config", "publisher-settings"], {}));
  const socialLinks = useSelector((state) => get(state, ["qt", "config", "social-links"], {}));
  const story =
    pageType === "custom-event-page"
      ? useSelector((state) => get(state, ["qt", "data", "eventStory"], {}))
      : useSelector((state) => get(state, ["qt", "data", "story"], {}));
  const { footerStatic: footerStaticMenu, footer: footerMenu } = navigationMenu;
  const { copyright = "" } = publisherSettings;
  const { OPEN_DESCRIPTION } = STATIC_KEYWORDS;
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  let adPageType = pageType;
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true";

  if (qtState.currentPath.includes("photos")) {
    adPageType = "photo-listing";
  } else if (qtState.currentPath.includes("videos")) {
    adPageType = "video-listing";
  } else if (qtState?.data?.story?.["story-template"] === "magazine") {
    adPageType = "magazine";
  } else if (qtState?.data?.section?.slug.includes("visual-stories")) {
    adPageType = "visual-stories";
  }

  return (
    <>
      {!isAdfree && <StickyAd pageType={adPageType} />}
      <div className="container" styleName={`${["magazine", "text"].includes(qtState?.data?.story?.["story-template"]) ? 'hide-breadcrumb' : ''} footer-wrapper`} id="footer">
        <BreadCrumb type={pageType} story={story} />
        <div styleName="footer">
          <div styleName="logo-follow-container">
            <div styleName="logo">
              <AppLogo customStyle="app-logo-footer" />
            </div>
            <div styleName="follow-us-container">
              <span styleName="follow-us-label">Follow us</span>
              <ul styleName="icons-container" aria-label="Follow us on social media">
                <FollowUsIcons socialLinks={socialLinks} />
              </ul>
            </div>
          </div>
          <span styleName="footer-description">{OPEN_DESCRIPTION}</span>
          <div styleName="menu-group-container">
            <MenuGroup menus={footerMenu} story={story} config={config} />
          </div>
          <div styleName="menu-group-static-container">
            <ul styleName="menu-group-static-items">
              <MenuGroup menus={footerStaticMenu} customStyle="static-list-item" isStatic="true" />
            </ul>
            <div styleName="copyright-text">{copyright}</div>
          </div>
        </div>
      </div>
    </>
  );
};
